import * as React from 'react';

import {
  createStyles,
  withStyles,
  WithStyles,
  Theme,
} from '@material-ui/core/styles';

import AppBar from 'ha/ui/next/AppBar';
import Toolbar from 'ha/ui/next/Toolbar';
import Grid from 'ha/ui/next/Grid';

import LanguageSwitcher from 'ha/modules/LanguageSwitcher';
import ListYourPlaceCTA from '../containers/ListYourPlaceCTA';
import NavBarLogo from './NavBarLogo';
import UnauthenticatedNavigation from './UnauthenticatedNavigation';
import AuthenticatedNavigation from '../containers/AuthenticatedNavigation.lazy';

const styles = (theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    appBar: {
      backgroundColor: '#fff',
    },
    toolbar: {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
    leftSpacing: {
      marginLeft: theme.spacing.unit * 2,
    },
  });

interface Props extends WithStyles<typeof styles> {
  breadcrumbs?: React.ReactElement<{ withoutFirstSeparator: boolean }> | null;
  isAuthenticated: boolean;
  isCTAVisible: boolean;
}

export const NavBarDesktop: React.SFC<Props> = ({
  breadcrumbs,
  isAuthenticated,
  classes,
  isCTAVisible,
}) => {
  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Grid spacing={8} alignItems="center" container>
          <Grid item>
            <NavBarLogo />
          </Grid>

          {breadcrumbs && (
            <Grid item>
              {React.cloneElement(breadcrumbs, {
                withoutFirstSeparator: false,
              })}
            </Grid>
          )}

          {/* Empty space that fills up available space */}
          <div className={classes.grow} />

          {isAuthenticated ? (
            <AuthenticatedNavigation />
          ) : (
            <UnauthenticatedNavigation />
          )}

          {isCTAVisible && (
            <Grid item>
              <ListYourPlaceCTA isAuthenticated={isAuthenticated} />
            </Grid>
          )}
          <Grid item>
            <div className={classes.leftSpacing}>
              <LanguageSwitcher />
            </div>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default withStyles(styles)(NavBarDesktop);
